import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SinglePaymentDetails = () => {
  const { paymentId } = useParams();
  const decodedId = paymentId ? atob(paymentId) : paymentId;
  const id = decodedId.replace(/\D/g, '');  // Ensure we only get the numeric part
  const [paymentDetails, setPaymentDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

    useEffect(() => {

        fetchInvoiceDetails();
        fetchPaymentDetails();
    }, [paymentId]);

    const fetchInvoiceDetails = async (invoiceId) => {
        try {
            const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${invoiceId}/`, { headers });
            return response.data;
        } catch (error) {
            console.error('Error fetching invoice details:', error);
        }
    };


      const fetchPaymentDetails = async () => {
            try {
                const response = await axios.get(`${API_DOMAIN}${API_ROUTES.payment}${id}/`, { headers });
                // const extractedColumns = Object.keys(response.data);
                const invoiceId = response.data.invoice;

                

                const invoiceDetails = await fetchInvoiceDetails(invoiceId);
                const invoiceNumber = invoiceDetails.invoice_number;
                
                const extractedColumns = [...Object.keys(response.data)];
                           
                response.data.invoice_number = invoiceNumber;
                extractedColumns.push('invoice_number');

                // Define which columns to exclude (if necessary)
                const excludedColumns = ['id', 'created_at', 'updated_at', 'invoice', 'customer', 'tax'];
                
                //console.log(invoiceNumber)
                const columnsArray = [...extractedColumns]
                .filter((column) => !excludedColumns.includes(column))
                .map((column) => {
               
                return {
                    label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
                    field: column,
                };
                });

                // columnsArray.push({
                //     label: 'Invoice Number',
                //     field: 'invoice_number',
                //   });


                    


                setColumnDetails(columnsArray);
                setPaymentDetails(response.data);
            } catch (error) {
                console.error('Error fetching payment details:', error);
            }
        };



  return (
    <div>
      {paymentDetails ? (
        <SingleItemDetailTemplate details={paymentDetails} columns={columns} />
      ) : (
        <p>Loading payment details...</p>
      )}
    </div>
  );
};

export default SinglePaymentDetails;